import styled from '@emotion/styled';
import { Link as TLink } from '~/lib';
import { breakpoints } from '~/theme/breakpoints';
import Button from '../../Button';
import { Link, StyledLink } from '../../Link';
import { SectionTitle } from './SectionTitle';

export type SummaryCategoriesProps = {
    title?: string;
    categories?: TLink[];
    className?: string;
    onToggle?: (category: string) => void;
};

const Wrapper = styled.div(({ theme }) => ({
    maxWidth: 'calc(100vw - 2px)',
    overflowX: 'auto',
    padding: theme.space[3],
    paddingTop: 0,
    display: 'flex',
    gap: theme.space[2],
    [breakpoints.sm]: {
        overflowX: 'unset',
        flexWrap: 'wrap',
    },
}));

export const SummaryCategories = styled(
    ({ className, title, categories, onToggle }: SummaryCategoriesProps) => (
        <div className={className}>
            {title && <SectionTitle>{title}</SectionTitle>}
            <Wrapper>
                {categories?.map((category) => (
                    <Link
                        key={category.id}
                        {...category}
                        href={category?.url}
                        onClick={() => category?.text && onToggle && onToggle(category.text)}
                    >
                        <Button tabIndex={-1} variant="tag">
                            {category?.text}
                        </Button>
                    </Link>
                ))}
            </Wrapper>
        </div>
    ),
)(({ theme }) => ({
    overflow: 'hidden',
    [`${SectionTitle}`]: {
        textAlign: 'left',
        borderBottom: 'none',
        paddingBottom: theme.space[2],
    },
    [`${StyledLink}`]: {
        flexShrink: 0,
    },
    [breakpoints.xs]: {
        overflow: 'hidden',
    },
}));
